import React, { Component } from "react";
import { View, Image, TouchableOpacity, FlatList } from 'react-native'
import { icons } from "../theme/icons";
import { appStyles, componentStyles, walletStyles, settingStyles } from '../theme/styles'
import TextView from "../components/TextView";
import LinearGradient from 'react-native-linear-gradient';
import { blueDarkColor, blueLightColor } from "../theme/colors";
import { notifictionRequest } from "../utils/api";
import Waiting from "../components/Waiting";
import { getError, persianNumber } from "../utils/utils";

export default class NotifictionScreen extends Component {
    constructor(props) {
        super(props)
        this.state = {
            waiting: true,
            notifictions: [],
        }
    }

    _keyExtractor = (item, index) => index.toString();
    renderRow({ item, index }) {
        return <View style={componentStyles.notifictionWraper}>
            <View style={appStyles.rowBetween}>
                <TextView style={{ color: 'gray' }}>{persianNumber(item.date)}</TextView>
                <TextView>{item.title}</TextView>
            </View>
            <TextView style={{ textAlign: 'right', paddingRight: 15, paddingLeft: 15 }}>{item.comment}</TextView>
        </View>
    }
    render() {
        return (<View style={appStyles.flex1}>
            <View style={appStyles.toolbarWraper}>
                <Image source={icons['ad']} style={[appStyles.toolbarIcon, { tintColor: '#31BFCF' }]} />
                <TextView style={appStyles.toolbarTitle}>اعلان ها</TextView>
                <TouchableOpacity onPress={() => {
                    this.props.navigation.goBack()
                }}>
                    <Image source={icons['back']} style={appStyles.backIcon} />
                </TouchableOpacity>
            </View>
            <LinearGradient colors={[blueDarkColor, blueLightColor]} style={[settingStyles.wraper, { paddingTop: 5 }]}>
                <FlatList
                    data={this.state.notifictions}
                    renderItem={this.renderRow.bind(this)}
                    keyExtractor={this._keyExtractor} />
                <Waiting waiting={this.state.waiting} />
            </LinearGradient>

        </View>)
    }

    componentWillMount() {
        notifictionRequest((isConnect, response) => {
            this.setState({
                waiting: false
            })
            if (isConnect && response.isSuccess) {
                this.setState({
                    notifictions: response.data
                })
            }
        })
    }

}